import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: 'login.component.html',
    styleUrls: ["./login.component.scss"],
})
export class LoginComponent {

    loading = false;
    login = this.fb.group({
        email: ['', Validators.required],
        password: ['', Validators.required]
    });

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private authService: AuthService
    ) {}

    onSubmit() {
        if (this.login.valid) {
            this.loading = true;

            this.authService.login(this.login.value).subscribe((data: any) => {
                localStorage.setItem('access_token', data.token);
                localStorage.setItem('netride_user_role', data.roles[0]);
                this.router.navigate(['/dashboard']);
            });
        }
    }

    showPassword: boolean = false;

	togglePassword(): void {
	    this.showPassword = !this.showPassword;
	}
}
